import Header from "../global/header";
import Footer from "../global/footer";
import Breadcrumbs from "../breadcrumbs";
import AllBlogs from "../all-blogs";
import bookData from "../../data/bookpage.json";

const AllBlog = ({headerv3, footer}) => {
  const {menuv2} = footer;

  return (
    <>
      <Header header={headerv3} />
      <Breadcrumbs isBg="yes" title="Books" />
      <AllBlogs isBg="" bookData={bookData} />
      <Footer isBg="yes" menu={menuv2} />
    </>
  );
};

export default AllBlog;
